import SvgComments from 'src/components/icons/comments';
// import Share from 'src/components/common/share/share';
import SvgEnthuse from 'src/components/icons/enthuse';
import { Avatar } from 'src/components/avatar';
import dayHepler from 'src/heplers/day';
import is from 'is_js';
import { isMobile } from 'react-device-detect';
import { ArticleDetailModal } from 'src/app/article/detail-modal';
import { useDisclosure } from '@chakra-ui/react';
import Router from 'next/router';
import { imageOptimize } from 'src/service/image';

interface Props {
  data: Object;
  className?: string;
  menu?: any;
}
const EpisodeFull = ({ data, className = '', menu }: Props) => {
  const episodeModal = useDisclosure();
  if (!data || is.empty(data)) {
    return null;
  }

  const link = `/reppl/${data['parent']}/episode/${data['contentID']}`;
  const linkHandle = (e) => {
    e.stopPropagation();
    // episodeModal.onOpen();
    Router.push(link);
  };

  const categories =
    data['categories'].length > 0 ? data['categories'].slice(0, 2) : [];
  return (
    <section
      className={`md:flex bg-white relative w-full picked-episode-card  rounded-sm overflow-hidden ${className}`}
    >
      <div className="absolute right-4 top-4">{menu}</div>
      <div className="relative w-full h-48 md:h-auto md:w-2/3 md:overflow-hidden flex-shrink-0">
        <img
          alt={data['title']}
          className="item-center cursor-pointer w-full"
          src={imageOptimize({
            url: data['coverImgURL'],
            imgContainer: 'postCover',
          })}
          onClick={(e) => linkHandle(e)}
          aria-hidden="true"
        />
        <div className="absolute px-6 md:y-4 bottom-0 md:bottom-4 flex justify-between w-full items-end">
          <div className="flex">
            <Avatar
              width={40}
              height={40}
              svgClassName="border border-white"
              src={
                imageOptimize({
                  url: data['author']['profileImgURL'],
                  imgContainer: 'postCover',
                }) || undefined
              }
            />
            <div className="ml-2">
              <span className="font-bold block text-white text-sm">
                {data['author']['username'] || '1TM Member'}
              </span>
              <span className="font-medium block text-xs text-gray-300">
                {data['author']['role'] || 'creator'}
              </span>
            </div>
          </div>
          {data['createdAt'] && (
            <span className="text-gray-300 text-xs font-semibold">
              {dayHepler.fromNow(data['createdAt'], true)}
            </span>
          )}
        </div>
      </div>
      <div className="pt-8 md:pt-14 px-6 md:w-1/3">
        <div
          onClick={(e) => linkHandle(e)}
          className="cursor-pointer"
          aria-hidden="true"
        >
          <div className="font-bold h-12 md:mt-3 md:h-18 w-full line-clamp line-clamp-2 md:text-2xl mt-1">
            {data['title']}
          </div>

          <p
            className={`text-sm text-gray-500 line-clamp ${
              isMobile
                ? 'h-10 mt-1 line-clamp-2 mb-2'
                : 'mt-2 line-clamp-5 mb-4'
            }  whitespace-pre-wrap`}
          >
            {data['excerpts']}
          </p>
          <div className="md:h-6 md:mb-10">
            {categories.map((category, key) => {
              const mkey = `${key}`;
              return (
                <span
                  key={mkey}
                  className="text-denim-500 bg-denim-50 text-xs rounded-full px-3 py-1 mx-0.5"
                >
                  {category}
                </span>
              );
            })}
          </div>
        </div>
        <div className="w-full text-gray-400 pt-2 mb-4 md:mt-10">
          <SvgEnthuse className="inline mr-1" />

          <span className="text-xs">
            {new Intl.NumberFormat().format(data['enthuseCount'])}
          </span>
          <span className="float-right">
            <a
              role="button"
              tabIndex={0}
              onClick={episodeModal.onOpen}
              onKeyDown={episodeModal.onOpen}
            >
              <SvgComments className="inline mr-3" />
            </a>
            {/* <Share link={link} /> */}
          </span>
        </div>
        <ArticleDetailModal
          source={data['source']}
          modal={episodeModal}
          publish
          id={data['contentID']}
        />
      </div>
      <ArticleDetailModal
        source={data['source']}
        modal={episodeModal}
        publish
        id={data['contentID']}
      />
    </section>
  );
};

export default EpisodeFull;
